
function CommonInput({inputValue, setInputValue, placeholder, readOnly}) {

  const handleClear = () => {
    setInputValue('');
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        className="border-[1px] border-[#D0D5DD] w-full h-[54px] rounded-lg px-4 mt-2 placeholder-[#AEB0B6]"
        placeholder={placeholder}
        readOnly={readOnly}
      />
      {(inputValue && !readOnly) && (
        <button
          className="absolute right-3 top-6"
          onClick={handleClear}
        >
          <img src="/assets/img/circle-x.svg" alt="x" />
        </button>
      )}
    </div>
  );
}

export default CommonInput;